import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup } from '@tencent/spaui';
import { withApi } from '@tencent/react-aio';
import Dialog from '@/components/Dialog';
import PotentialStatusSelect from '@/components/PotentialStatusSelect';
import BatchReleaseBlackList from '../usercenter/BatchReleaseBlackList';
import PotentialReasonSelect from '@/business-components/sale/PotentialReasonSelect';
import MessageBox from '@/components/MessageBox';
import Delegate from '@/components/Delegate';
import { toPotentialDefaultConfig } from '@/constants/Constants';
import * as ActionTypes from '@/stores/sale/actions';
import _ from 'lodash';

class Turn2PotentialModal extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    lead: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      potentialStatus: toPotentialDefaultConfig.potentialStatus,
      transactionProbability: toPotentialDefaultConfig.transactionProbability,
      potentialSecondSeasonType:
        toPotentialDefaultConfig.potentialSecondSeasonType,
    };
    this.releaseBlackListModal = React.createRef();
  }

  render() {
    const { lead } = this.props;
    const { description, error, disableToPotential } = this.state;

    const Content = (props) => {
      const [inputValue, setInputValue] = useState(props.iptValue);
      return (
        <div>
          {this.renderPotential()}
          <FormGroup className={'required with-textarea'}>
            <label htmlFor={'description'}>跟进情况：</label>
            <textarea
              id={'description'}
              className="spaui-input"
              minLength={3}
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              onBlur={() => {
                props.setIpt({ target: { value: inputValue } });
              }}
            />
          </FormGroup>
          {error && (
            <p className={'has-error'}>
              <span className={'error-message'}>
                发生错误：{error.message || '服务器错误'}
              </span>
            </p>
          )}
        </div>
      );
    };

    if (this.props.notDialog) {
      return (
        <div className="phone-follow-up-content CreateActionRecordModal">
          <h4>转为商机</h4>
          <Content
            iptValue={description}
            setIpt={this.handleChangeDescription}
          />
          <div className="phone-follow-up-content-confirm">
            <Button onClick={this.handleSubmit}>确定</Button>
          </div>
        </div>
      );
    }

    return (
      <Dialog
        className="CreateActionRecordModal"
        title="转为商机"
        subTitle={lead?.company?.companyName}
        {...this.props}
        style={{ width: 640 }}
        onSubmit={this.handleSubmit}
        disabled={disableToPotential}
      >
        <Content iptValue={description} setIpt={this.handleChangeDescription} />
      </Dialog>
    );
  }

  renderPotential() {
    const {
      potentialStatus,
      transactionProbability,
      potentialSecondSeasonType,
    } = this.state;
    return (
      <React.Fragment>
        <FormGroup className={'with-select required'}>
          <label htmlFor={'potentialStatus'}>商机状态：</label>
          <PotentialStatusSelect
            usePotentialStatusNew
            id={'potentialStatus'}
            mode={'block'}
            potentialStatus={potentialStatus}
            transactionProbability={transactionProbability}
            onChange={this.handleChangePotentialStatus}
          />
        </FormGroup>
        {potentialStatus && (
          <FormGroup className={'with-select required'}>
            <label htmlFor={'potentialStatus'}>意向原因：</label>
            <PotentialReasonSelect
              potentialStatus={`${potentialStatus}-${transactionProbability}`}
              value={potentialSecondSeasonType}
              onChange={this.handlePotentialSecondSeasonType}
            />
          </FormGroup>
        )}
        <Delegate
          ref={this.releaseBlackListModal}
          component={BatchReleaseBlackList}
        />
      </React.Fragment>
    );
  }

  handleChangePotentialStatus = (e, value) => {
    const { potentialStatus, transactionProbability } = value;
    this.setState({
      potentialStatus,
      transactionProbability,
      error: undefined,
      potentialSecondSeasonType: undefined,
    });
  };

  handlePotentialSecondSeasonType = (e, potentialSecondSeasonType) => {
    this.setState({ potentialSecondSeasonType });
  };

  handleChangeDescription = (e) => {
    this.setState({
      description: e.target.value,
      error: undefined,
    });
  };

  handleSubmit = () => {
    const {
      potentialStatus,
      transactionProbability,
      description,
      potentialSecondSeasonType,
    } = this.state;
    const { webApi, lead, onSubmit } = this.props;

    // 数据校验
    if (!potentialStatus || !description || !potentialSecondSeasonType) {
      return;
    }

    // 提交
    this.setState({
      error: undefined,
      disableToPotential: true,
    });

    const toPotentialParam = {
      // potentialOwnerId: lead.ownerId,
      version: lead?.version,
      potentialStatus,
      transactionProbability,
      description,
      potentialSecondSeasonType,
    };

    webApi
      .toPotential(lead?.leadId)
      .dispatchJson(ActionTypes.TO_POTENTIAL, {
        data: toPotentialParam,
      })
      .then(
        (res) => {
          this.setState({
            disableToPotential: false,
          });

          if (res.code === 0) {
            if (!_.isEmpty(res.blackList)) {
              this.releaseBlackListModal.current.show({
                title: '成功转为商机',
                contactPhones: res.blackList,
                onSubmit: () => {
                  onSubmit();
                  this.context.success('成功转为商机');
                },
                onCancel: () => {
                  onSubmit();
                  this.context.success('成功转为商机, 释放对应黑名单成功');
                },
              });
            } else {
              onSubmit();
            }
          }

          if (res.code === 400) {
            this.context.error('转化商机失败', res.message);
          }
        },
        (error) => {
          this.setState({
            disableToPotential: false,
          });
          this.context.error('转化商机失败', error.message);
        }
      );
  };
}

export default withApi(Turn2PotentialModal);

Turn2PotentialModal.contextType = MessageBox;
